/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FontVariantV1Dto } from './FontVariantV1Dto';
export type FontObjectV1Dto = {
  /**
   * The font family
   */
  family: FontObjectV1Dto.family;
  /**
   * The font color in HEX format
   */
  color: string;
  /**
   * The font size
   */
  size: number;
  /**
   * The font variants
   */
  variants: FontVariantV1Dto;
};
export namespace FontObjectV1Dto {
  /**
   * The font family
   */
  export enum family {
    INCONSOLAT = 'Inconsolat',
    OPEN = 'Open',
    SANS = 'Sans',
    LATO = 'Lato',
    RALEWAY = 'Raleway',
    MERRIWEATHER = 'Merriweather',
    EB_GARAMOND = 'EB Garamond',
    COMIC_NEUE = 'Comic Neue',
    MONACO = 'Monaco',
    HELVETICA = 'Helvetica',
    COURIER = 'Courier',
    TIMES_ROMAN = 'Times Roman',
  }
}
